import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list, Mix } from "Utils/Reflection";
import * as Topics from "Data/Topics";

import {ch1_p014} from "../../../layouts/ch1_p14/ch1_p014";

export class Chapter1Page14 extends AbstractStoryState {

	readonly background = this.addChild(new SceneSprite());
	readonly island = this.addChild(new SceneSprite());
	readonly holly = list(()=>this.addChild(new SceneSprite()));
	readonly chores = this.addChild(new SceneSprite());
	readonly choresCounter = this.addChild(new SceneSprite());
	readonly sigh = this.addChild(new SceneSprite());
	readonly friends = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(new SceneSprite());
    readonly frameRight = this.addChild(new SceneSprite());
	readonly lines = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
        // exported layout from Animate CC
        ch1_p014.call(this);
        this.frameLeft.visible = false;
        this.frameRight.visible = false;

        // initial state
        this.holly[0].visible = true;
        this.holly[1].visible = false;
        this.holly[2].visible = false;

        this.choresCounter.visible = true;
        this.sigh.visible = false;
        this.chores.visible = false;
        this.friends.visible = false;

        // interaction
        this.choresCounter.interactive = true;
        this.choresCounter.buttonMode = true;
        this.choresCounter.accessible = true;
        this.choresCounter.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            HLF.Application.instance.audio.play("HollyChoresListOpt1", undefined, false, HLF.AudioCategory.SFX);
            PubSub.publishSync(Topics.HIDE_ALL_HINTS, undefined);

            this.holly[0].FadeOut();
            this.holly[1].FadeIn();
            this.choresCounter.FadeOut();
            this.sigh.FadeOut();
            this.chores.FadeIn();
            new TimelineLite().from(this.chores, 0.5, {pixi: {
                y: this.chores.position.y + 100,
            }})
            .call(()=>{
                this.showHint(this.chores, "hand", 8);
            });
        });

        this.chores.interactive = true;
        this.chores.buttonMode = true;
        this.chores.accessible = true;

        const dismissChoresTimeline = new TimelineLite();

        const dismissChores = () => {
            PubSub.publishSync(Topics.HIDE_ALL_HINTS, undefined);

            // fade and slide out chores
            this.chores.FadeOut();
            dismissChoresTimeline
                .to(this.chores, 0.5, {pixi: {
                    x: this.chores.position.x + 200,
                }}, 0)
                // 0.5 seconds after complete, crossfade holly and friends
                .call(()=>{
                    this.friends.FadeIn();
                    this.holly[1].FadeOut();
                    this.holly[2].FadeIn();
                }, undefined, undefined, 1)
                // and scale up friends
                .from(this.friends, 0.5, {pixi: {
                    scale: this.friends.scale.x * 0.3,
                }}, 1)
                .call(()=>{
                    this.friends.hintScale = 1.01;
                    this.showHint(this.friends, "pulse"); // start hint after scale up complete
                })
            ;
        }
        // this.chores.onDragEnd.push(dismissChores);
        this.chores.addListener(HLF.Input.Events.MOUSE_DOWN, dismissChores);
        this.chores.addListener(HLF.Input.Events.TOUCH_MOVE, dismissChores);

        this.friends.interactive = true;
        this.friends.buttonMode = true;
        this.friends.accessible = true;
        this.friends.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            dismissChoresTimeline.kill();
            PubSub.publishSync(Topics.HIDE_ALL_HINTS, undefined);
            this.friends.interactive = false;
            this.gotoNextState({transition: "up"});
        });

		// super.init calls onResize
		super.init(pSize, pData);
    }

    public animateIn(pOnComplete: ()=> void): void {
        super.animateIn(pOnComplete);
        new TimelineLite().call(()=>this.sigh.FadeIn()).delay(3);
        this.showHint(this.choresCounter, "pulse", 3.5);
    }
}